<template>
  <!-- 通过v-model绑定fileList -->
  <div>
    <el-upload
      :action="uploadUrl"
      :headers="{ Authorization: 'Bearer ' + token, AppCode: 'roses-platform' }"
      :multiple="false"
      :file-list="fileList"
      :limit="limitNum"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :show-file-list="isShowList"
      :on-change="handleChange"
      list-type="picture"
      :accept="acceptType"
      :class="{ 'detail-upload': isDisabled }"
    >
      <template v-if="!isDisabled">
        <el-button size="small" type="text">点击上传</el-button>
      </template>
    </el-upload>
  </div>
</template>

<script>
import config from '@/config';
import { mapGetters } from 'vuex';

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },

    limitNum: {
      type: Number,
      default: 9
    },
    acceptType: {
      type: String,
      default: '.pdf,.doc,.docx,.mp4,.avi,.ofd,.png,.jpg,.jpeg,.rar '
    },
    isShowList: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['token']),
    uploadUrl() {
      return `${config.base_url}/biz-support-file/file/uploadWithFileInfo`;
    }
  },
  data() {
    return {
      config,
      disabled: false,
      fileIdList: [],
      fileList: []
    };
  },
  created() {},
  methods: {
    // handleRemove(file) {
    //   let removeFileId = '';
    //   if (file.response) {
    //     removeFileId = file.response.data;
    //   } else {
    //     removeFileId = file.id;
    //   }
    //   this.fileIdList.splice(this.fileIdList.indexOf(removeFileId), 1);
    //   this.$emit('get-file-data', this.fileIdList);
    // },
    beforeUpload(file) {
      // console.log(file);
      const suffix = file.name.split('.')[file.name.split('.').length - 1];
      const isRarFile = suffix === 'rar' || suffix === 'zip';
      const requireType = [
        'image/jpg',
        'image/png',
        'image/gif',
        'image/jpge',
        'image/jpeg',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
        'application/octet-stream',
        'video/mp4',
        'video/x-msvideo'
      ];
      const isRequireType = requireType.indexOf(file.type) >= 0;
      if (!isRequireType && !isRarFile) {
        this.$message.error('上传文件类型错误!');
      }
      const isLt300M = file.size / 1024 / 1024 < 300;
      if (!isLt300M) {
        this.$message.error('上传图片大小不能超过300MB!');
      }
      return (isRequireType || isRarFile) && isLt300M;
    },
    handleChange(file, fileList) {
      this.returnUpload(fileList);
    },
    returnUpload(fileList) {
      this.fileList = fileList;
    },
    // 超出文件个数钩子
    handleExceed() {
      this.$message.error(`最多只能上传${this.limitNum}个文件`);
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.fileList = newVal;
      }
    },
    fileList: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-upload__tip {
  display: inline;
}

.detail-upload/deep/.el-upload--picture {
  display: none;
}
</style>
